<div
  [attr.aria-multiselectable]="true"
  [id]="filter.id"
  role="listbox"
  tabindex="0"
  class="l_flex l_flex-column l_flex-top-children guts-p-b-1 guts-p-h-quart"
>
  <ng-container
    *ngFor="let filterOption of filter.subitems"
    data-dgat="search-filter-sidebar-options-bd8"
  >
    <button
      role="option"
      class="search-filter-sidebar-option"
      (click)="toggleSelected(filterOption)"
      [ngClass]="{
        'search-filter-sidebar-option--selected': filterOption.isSelected
      }"
      data-dgat="search-filter-sidebar-option-8cd"
    >
      <input
        class="guts-m-r-1"
        type="checkbox"
        tabindex="-1"
        [checked]="filterOption.isSelected"
        readonly="readonly"
        data-dgat="search-filter-sidebar-option-79a"
      />
      <span class="font-medium ellipsis" [attr.title]="filterOption.title">
        {{ filterOption.title }}
      </span>
      <span
        class="search-filter-sidebar-option--count"
        *ngIf="showCount(filterOption)"
      >
        {{ getContentCount(filterOption) }}
      </span>
    </button>
  </ng-container>
</div>
